import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RotatedSortIcon } from "../../shared/components/TableFilter";
import { WarehouseLocation } from "../../../interfaces/document";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface LocationsTableProps {
  data: WarehouseLocation[];
  handeSortChange: (state: "ASC" | "DESC") => void;
  handleOrderTypeChange: (type: string) => void;
  order: "ASC" | "DESC";
  orderType: string;
  onDeleteClick: (location: WarehouseLocation) => void;
  onEditClick: (location: WarehouseLocation) => void;
}

const LocationsTable = ({
  data,
  handeSortChange,
  handleOrderTypeChange,
  order,
  orderType,
  onDeleteClick,
  onEditClick,
}: LocationsTableProps) => {
  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          minWidth: 300,
          "& .MuiTableCell-root": {
            padding: { xs: 2, sm: 4 },
          },
          "& .actions-cell": {
            width: "100px",
            whiteSpace: "nowrap",
          },
        }}
        size="small"
        aria-label="locations table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              onClick={() => {
                handeSortChange(order === "ASC" ? "DESC" : "ASC");
                handleOrderTypeChange("name");
              }}
            >
              Nome Ubicazione
              {orderType === "name" && (
                <IconButton size="small">
                  <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                </IconButton>
              )}
            </TableCell>
            <TableCell align="right" className="actions-cell">
              Azioni
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: WarehouseLocation) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right" className="actions-cell">
                <IconButton
                  color="primary"
                  onClick={() => onEditClick(row)}
                  size="small"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  color="error"
                  onClick={() => onDeleteClick(row)}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LocationsTable;
